(function () {
  const TS_SHELF_PATHS = new Set([
    '/collections/tools-and-supplies',
    '/collections/brushes',
    '/collections/drills',
    '/collections/tweezers',
    '/collections/scribing-tools',
    '/collections/scratch-building',
    '/collections/adhesives',
    '/collections/cutting-mats',
    '/collections/nippers-and-knives',
    '/collections/sanding',
    '/collections/tapes',
    '/collections/markers',
    '/collections/paints',
    '/collections/panel-liners',
    '/collections/decals',
    '/collections/airbrush',
    '/collections/weathering',
    '/collections/workshop-misc',
  ]);

  if (!TS_SHELF_PATHS.has(window.location.pathname)) {
    return;
  }

  /**
   * @returns {'1'|'0'|null}
   */
  function availabilityMode() {
    const fromUrl = new URLSearchParams(window.location.search).get('filter.v.availability');
    if (fromUrl === '1' || fromUrl === '0') {
      return fromUrl;
    }

    const checked = document.querySelector(
      '#FacetFiltersForm input[name="filter.v.availability"]:checked, #FacetFiltersFormMobile input[name="filter.v.availability"]:checked',
    );

    if (!(checked instanceof HTMLInputElement)) {
      return null;
    }

    return checked.value === '0' ? '0' : '1';
  }

  /**
   * @param {Element} item
   */
  function itemPassesAvailability(item) {
    const mode = availabilityMode();
    if (!mode) {
      return true;
    }

    const available = item.getAttribute('data-ovs-available') === 'true';
    if (mode === '1') {
      return available;
    }

    return !available;
  }

  /**
   * @param {() => void} callback
   */
  function onGridUpdated(callback) {
    document.addEventListener('ovs:product-grid-updated', callback);
  }

  /**
   * @param {() => void} callback
   */
  function onAvailabilityChanged(callback) {
    document.addEventListener('ovs:availability-filter-changed', callback);
  }

  document.addEventListener(
    'input',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) {
        return;
      }

      if (target.name !== 'filter.v.availability') {
        return;
      }

      document.dispatchEvent(new CustomEvent('ovs:availability-filter-changed'));
    },
    true,
  );

  window.OvsTsFilterUtils = {
    availabilityMode,
    itemPassesAvailability,
    onGridUpdated,
    onAvailabilityChanged,
  };
})();
